import { PitchbookInvestorComponent } from "@/features"

export const PitchbookInvestorPage = () => {
  return <PitchbookInvestorComponent />
}
